import { render, staticRenderFns } from "./Prometheus.vue?vue&type=template&id=0a5926be&scoped=true&"
import script from "./Prometheus.vue?vue&type=script&lang=js&"
export * from "./Prometheus.vue?vue&type=script&lang=js&"
import style0 from "./Prometheus.vue?vue&type=style&index=0&id=0a5926be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5926be",
  null
  
)

export default component.exports